export default __webpack_public_path__ + "static/media/closed.5dce97fa.png";